var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    title,
    overallPercent,
    rateChangeArrow,
    rateChange
  } = options;

__p+='\n\n\n<span class="loan display-block">'+
((__t=( title ))==null?'':__t)+
'</span>\n<span class="rate">'+
((__t=( overallPercent ))==null?'':__t)+
'</span>\n<i class="ra ra-arrow-'+
((__t=( rateChangeArrow ))==null?'':__t)+
'" />\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/hp_rate_trends_title.jst.ejs